module.exports = __webpack_public_path__ + "static/media/answer.c1f3d8cf.svg";